var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "url(#paint0_linear_482_3762)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7914 18.6082C27.0355 18.3989 27.1575 18.2943 27.2023 18.1698C27.2415 18.0605 27.2415 17.941 27.2023 17.8317C27.1575 17.7072 27.0355 17.6026 26.7914 17.3934L18.3206 10.1328C17.9004 9.77256 17.6903 9.59246 17.5124 9.58804C17.3578 9.58421 17.2101 9.65213 17.1124 9.77201C17 9.90995 17 10.1867 17 10.7402V15.0354C14.8653 15.4089 12.9116 16.4905 11.4597 18.1146C9.87682 19.8853 9.00123 22.1767 9 24.5517V25.1637C10.0493 23.8996 11.3595 22.8773 12.8408 22.1667C14.1467 21.5402 15.5584 21.1691 17 21.0713V25.2614C17 25.8149 17 26.0916 17.1124 26.2296C17.2101 26.3494 17.3578 26.4174 17.5124 26.4135C17.6903 26.4091 17.9004 26.229 18.3206 25.8688L26.7914 18.6082Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3762",
    x1: 18,
    y1: -0.00000107288,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#008500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#008500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.83dcd798713f04af6846ce2768a177bb.svg";
export { ForwardRef as ReactComponent };